// extracted by css-extract-rspack-plugin
export default {"screen":"ReloadScreen-module__screen___P8iaZ","note":"ReloadScreen-module__note___nzd2F"};